//import { listenersService, htmlService } from '@Engage.Core';
import { userAgent } from '@Core/utils/UserAgent';
import { listenersService } from '@Core/dom/services/ListenersService';
import { htmlService } from '@Core/dom/services/HtmlService';
class Dom {
    constructor() {
        this.connextScriptClass = 'nxt-script';
    }
    removeAllEventListeners() {
        listenersService.removeAllListeners();
    }
    parseVariables(html, variables) {
        if (!variables)
            variables = {};
        // Save scripts separately
        const scripts = [];
        html = html.replace(/<script[\s\S]*?<\/script>/gi, (match) => {
            scripts.push(match);
            return `__SCRIPT_PLACEHOLDER_${scripts.length - 1}__`;
        });
        // Step 1: Replace {{variable}}
        html = html.replace(/{{([\w]+)}}/g, (_, key) => {
            var _a;
            return variables.hasOwnProperty(key) ? ((_a = variables[key]) !== null && _a !== void 0 ? _a : '') : '';
        });
        // Step 2: Replace inline functions (outside <script>)
        const funcRegex = /(?:function\s*\([\w\s,]*\)\s*\{[\s\S]*?\})|(?:\([\w\s,]*\)\s*=>\s*(?:\{[\s\S]*?\}|[^;]+))/g;
        html = html.replace(funcRegex, (match) => {
            try {
                const fn = new Function(`return ${match}`)();
                const result = typeof fn === 'function' ? fn() : fn;
                return result != null ? result.toString() : '';
            }
            catch (e) {
                console.warn("Execution failed for:", match, e);
                return '';
            }
        });
        // Restore scripts
        html = html.replace(/__SCRIPT_PLACEHOLDER_(\d+)__/g, (_, idx) => scripts[+idx]);
        return html;
    }
    getMatches(sourceString, regex, index) {
        index || (index = 1); // default to the first capturing group
        let matches = [];
        let match;
        while (match = regex.exec(sourceString)) {
            matches.push(match[index]);
        }
        return matches;
    }
    queryElement(selector, parent) {
        let lookUp = parent ? parent : document;
        return typeof selector === 'object' ? selector : lookUp.querySelector(selector);
    }
    getElementsByClassName(element, classNAME) {
        if (!element) {
            return [];
        }
        return htmlService.nodeListToArray(element.getElementsByClassName(classNAME));
    }
    toogleClass(element, className) {
        if (!element) {
            return null;
        }
        if (htmlService._isIterable(element)) {
            Array.from(element).forEach((elItem) => {
                this.toogleClass(elItem, className);
            });
            return Dom;
        }
        element.classList.toggle(className);
    }
    addClass(element, className) {
        if (!element) {
            return null;
        }
        if (htmlService._isIterable(element)) {
            Array.from(element).forEach((elItem) => {
                this.addClass(elItem, className);
            });
            return Dom;
        }
        element.classList.add(className);
    }
    removeClass(element, className) {
        if (!element) {
            return null;
        }
        if (htmlService._isIterable(element)) {
            const elementsLength = element.length;
            for (let i = 0; i < elementsLength; i++) {
                if (!htmlService.isNode(element[i])) {
                    console.error("Dom.removeClass" + element[i] + " is not a DOMNode object");
                    return null;
                }
                else {
                    this.removeClass(element[i], className);
                }
            }
        }
        if (!htmlService.isNode(element)) {
            console.error("Dom.removeClass" + element + " is not a DOMNode object");
            return null;
        }
        element.classList.remove(className);
    }
    ;
    hasClass(element, classNAME) {
        return element.classList.contains(classNAME);
    }
    on(element, event, handler, options) {
        if (!element) {
            return null;
        }
        if (Array.isArray(element) && element.length == 0) {
            return;
        }
        let events = event.split(' ');
        if (events.length > 1) {
            for (let i = 0, iLen = events.length; i < iLen; i++) {
                this.on(element, events[i], handler);
            }
            return this;
        }
        if (typeof element === 'string') {
            const bodyHandler = function (e) {
                let target = e.target;
                while (target && target !== this) {
                    if (target.matches(element)) {
                        handler.call(target, e);
                        return;
                    }
                    target = target.parentNode;
                }
            };
            htmlService.addEventListener(document.body, event, bodyHandler);
            return this;
        }
        if (htmlService._isIterable(element)) {
            Array.from(element).forEach((e, index) => {
                this.on(e, event, handler);
            });
            return this;
        }
        htmlService.addEventListener(element, event, handler);
        return this;
    }
    removeConnextListeners() {
        // off all elements, which has _event - obejct for storing our handlers
        htmlService.nodeListToArray(document.querySelectorAll('*')).concat([window])
            .filter(element => element._event)
            .forEach(element => {
            Object.keys(element._event).forEach(event => {
                // looping through array and removing items, without breaking for loop
                const handlers = element._event[event].handlers;
                for (let idx = handlers.length - 1; idx >= 0; idx--) {
                    if (element) {
                        this.off(element, event, handlers[idx]);
                    }
                }
            });
        });
    }
    off(element, event, handler) {
        if (!element) {
            return null;
        }
        if (htmlService._isIterable(element)) {
            Array.from(element).forEach((e, index) => {
                this.off(e, event, handler);
            });
            return this;
        }
        htmlService.removeEventListener(element, event, handler);
        return this;
    }
    one(element, event, handler) {
        let that = this;
        this.on(element, event, function handlerWrapper(e) {
            handler(e);
            that.off(element, event, handlerWrapper);
        });
    }
    setFocus(element) {
        element.focus ? element.focus() : element.setActive();
    }
    createElement(html) {
        return document.createElement(html);
    }
    cleanIdSelector(selector) {
        (selector.match(/(#[0-9][^\s:,]*)/g) || []).forEach(function (n) {
            selector = selector.replace(n, '[id="' + n.replace("#", "") + '"]');
        });
        return selector;
    }
    ;
    find(selector, element) {
        let result;
        const pattern = /:visible/g;
        const isVisible = pattern.test(selector);
        if (isVisible) {
            selector = selector.split(pattern).join('');
        }
        selector = this.cleanIdSelector(selector);
        if (htmlService.isNode(element)) {
            result = htmlService.nodeListToArray(element.querySelectorAll(selector));
        }
        else {
            result = htmlService.nodeListToArray(document.querySelectorAll(selector));
        }
        if (isVisible) {
            return dom.isVisible(result);
        }
        return result;
    }
    findByChild(selector, element) {
        let result = document.querySelectorAll(selector)[1];
        return result;
    }
    css(element, style) {
        if (htmlService._isIterable(element)) {
            Array.from(element).forEach((e) => {
                this.css(e, style);
            });
            return Dom;
        }
        if (!htmlService.isNode(element)) {
            console.error(element + " is not a DOMNode object");
            return null;
        }
        // get one property value
        if (typeof style === "string") {
            return htmlService._getComputedStyle(element, style);
        }
        if (htmlService._isLiteralObject(style)) {
            // set csses
            for (let i in style) {
                element.style[i] = style[i];
            }
            return style;
        }
        else {
            return null;
        }
    }
    ;
    height(element) {
        return this.offset(element).height;
    }
    width(element) {
        return this.offset(element).width;
    }
    top(element) {
        return this.offset(element).top;
    }
    bottom(element) {
        return this.offset(element).bottom;
    }
    offset(element) {
        if (!htmlService.isElement(element)) {
            return false;
        }
        let rect = element.getBoundingClientRect();
        let offset = {
            top: Math.round(rect.top),
            right: Math.round(rect.right),
            bottom: Math.round(rect.bottom),
            left: Math.round(rect.left),
            width: rect.width ? Math.round(rect.width) : Math.round(element.offsetWidth),
            height: rect.height ? Math.round(rect.height) : Math.round(element.offsetHeight)
        };
        // // fallback to css width and height
        // if (offset.width <= 0) {
        //     offset.width = parseFloat(htmlService._getComputedStyle(element, 'width'));
        // }
        // if (offset.height <= 0) {
        //     offset.height = parseFloat(htmlService._getComputedStyle(element, 'height'));
        // }
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        offset.top = rect.top + scrollTop;
        offset.left = rect.left + scrollLeft;
        offset.bottom = rect.bottom + scrollTop;
        return offset;
    }
    ;
    remove(element) {
        if (!element) {
            return null;
        }
        if (htmlService._isIterable(element)) {
            Array.from(element).forEach((elementNode) => {
                this.remove(elementNode);
            });
            return null;
        }
        if (!htmlService.isNode(element)) {
            console.error("Dom.remove " + element + " is not a DOMNode object");
            return null;
        }
        const parent = element.parentNode;
        if (parent) {
            return parent.removeChild(element);
        }
    }
    ;
    children(element, tag) {
        if (!element) {
            return [];
        }
        if (typeof tag === 'boolean' && tag) {
            return element.childNodes;
        }
        let result = [];
        if (typeof tag === 'string') {
            for (let i = 0, j = element.childNodes.length; i < j; i++) {
                if (element.childNodes[i].nodeName.toLowerCase() === tag.toLowerCase()) {
                    result.push(element.childNodes[i]);
                }
            }
            return result;
        }
        for (let i in element.childNodes) {
            if (element.childNodes[i].nodeType === 1) {
                result.push(element.childNodes[i]);
            }
        }
        return result;
    }
    ;
    append(element, html) {
        let appendElement;
        let returnHtmlElement;
        if (!htmlService.isNode(element)) {
            console.error("Dom.append " + element + " is not a DOMNode object");
            return null;
        }
        if (typeof html === 'string') {
            appendElement = this.create(html);
        }
        else {
            appendElement = html;
        }
        if (userAgent.isIE()) {
            //fixes WrongDocumentError in IE
            returnHtmlElement = document.importNode(appendElement, true);
        }
        returnHtmlElement = element.appendChild(appendElement);
        this.findexecuteScript(returnHtmlElement);
        return returnHtmlElement;
    }
    ;
    removeScripts(html) {
        return html.replace(/<\s*script[^>]*>([\s\S]*?)(<\s*\/script[^>]*>|$)/ig, " ");
    }
    DOMEval(code) {
        const script = document.createElement("script");
        script.classList.add(this.connextScriptClass);
        script.text = code;
        dom.queryElement('body').appendChild(script);
    }
    findexecuteScript(element) {
        let scriptCodes = this.find('script', element);
        let scripts = [];
        if (scriptCodes && scriptCodes.length > 0) {
            scriptCodes.forEach((scriptElement) => {
                let replaceScript = this.replaceScript(scriptElement);
                scripts.push(replaceScript);
            });
            this.restoreScripts(scripts);
        }
    }
    replaceScript(element) {
        let placeholder = document.createComment('Script placeholder');
        element.parentNode.insertBefore(placeholder, element);
        element.parentNode.removeChild(element);
        return {
            placeholder: placeholder,
            node: element
        };
    }
    ;
    restoreScripts(scripts) {
        scripts.forEach((script) => {
            const scriptEl = document.createElement("script");
            Array.from(script.node.attributes).forEach((attribute) => {
                scriptEl.setAttribute(attribute.name, attribute.value);
            });
            scriptEl.text = script.node.innerHTML;
            scriptEl.classList.add(this.connextScriptClass);
            dom.queryElement('body').appendChild(scriptEl);
        });
    }
    ;
    create(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.firstChild;
    }
    ;
    html(element, html) {
        if (!element) {
            return null;
        }
        if (htmlService._isIterable(element)) {
            return this.html(element[0], html);
        }
        if (typeof html === 'string' || typeof html === 'number') {
            element.innerHTML = html;
            return html;
        }
        return element.innerHTML;
    }
    ;
    hide(elements) {
        if (!elements)
            return;
        if (htmlService._isIterable(elements)) {
            Array.from(elements).forEach((element) => {
                this.hide(element);
            });
            return this;
        }
        elements.style.display = 'none';
    }
    show(elements) {
        if (htmlService._isIterable(elements)) {
            Array.from(elements).forEach((element) => {
                this.show(element);
            });
            return this;
        }
        if (!htmlService.isNode(elements)) {
            return null;
        }
        if (elements.getAttribute("data-nxt-template-substep") ||
            elements.getAttribute("data-nxt-template-step")) {
            elements.style.display = 'block';
        }
        else {
            elements.style.display = '';
        }
    }
    attr(element, attribute) {
        if (!htmlService.isNode(element)) {
            console.error(element + " is not a DOMNode object");
            return null;
        }
        // get one attribute
        if (typeof attribute === "string") {
            let result;
            if (attribute === 'class' && element['className'] !== undefined) { // class?
                result = element.className;
            }
            else if (attribute === 'for' && element['htmlFor'] !== undefined) { // for?
                result = element.htmlFor;
            }
            else if (attribute === 'value' && element['value'] !== undefined) { // value?
                result = element.value;
            }
            else {
                result = element.getAttribute(attribute);
            }
            if (result === '') {
                result = null;
            }
            return result;
        }
        // set attribute(s)
        if (htmlService._isLiteralObject(attribute)) {
            for (let i in attribute) {
                if (attribute[i] === null) {
                    element.removeAttribute(i);
                }
                else {
                    element.setAttribute(i, attribute[i]);
                }
            }
            return attribute;
        }
        else {
            return null;
        }
    }
    ;
    before(element, html) {
        if (!htmlService.isNode(element)) {
            console.error("Dom.before " + element + " is not a DOMNode object");
            return null;
        }
        let newElementFromHtml;
        if (typeof html === "string") {
            newElementFromHtml = this.create(html);
        }
        else {
            newElementFromHtml = html;
        }
        element.parentNode.insertBefore(newElementFromHtml, element);
        this.findexecuteScript(newElementFromHtml);
        return html;
    }
    ;
    inAsFirstChild(element, html) {
        if (!htmlService.isNode(element)) {
            console.error("Dom.before " + element + " is not a DOMNode object");
            return null;
        }
        if (typeof html === 'string') {
            html = this.create(html);
        }
        element.insertBefore(html, element.firstChild);
        this.findexecuteScript(html);
        return html;
    }
    ;
    inAsLastChild(element, html) {
        if (!htmlService.isNode(element)) {
            console.error("Dom.before " + element + " is not a DOMNode object");
            return null;
        }
        if (typeof html === 'string') {
            html = this.create(html);
        }
        element.appendChild(html);
        this.findexecuteScript(html);
        return html;
    }
    ;
    after(element, html) {
        if (!htmlService.isNode(element)) {
            console.error("Dom.before " + element + " is not a DOMNode object");
            return null;
        }
        if (typeof html === 'string') {
            html = this.create(html);
        }
        element.parentNode.insertBefore(html, element.nextSibling);
        this.findexecuteScript(html);
        return html;
    }
    ;
    val(element, value) {
        let result = [];
        if (htmlService._isIterable(element)) {
            Array.from(element).forEach((elementNode) => {
                result.push(this.val(elementNode, value));
            });
            return result[0];
        }
        if (!htmlService.isNode(element)) {
            console.error("Dom.before " + element + " is not a DOMNode object");
            return null;
        }
        if (!value) {
            return element.value;
        }
        element.value = value;
    }
    getCssAttribute(element, attributeName) {
        let styleItems = this.getStyles(element);
        return styleItems[attributeName];
    }
    getTextElement(element) {
        if (!htmlService.isNode(element)) {
            console.log("Dom.text " + element + " is not a DOMNode object");
            return null;
        }
        if (element.innerText) {
            return element.innerText;
        }
        else {
            return element.textContent;
        }
    }
    setTextElement(element, text) {
        if (!htmlService.isNode(element)) {
            console.log("Dom.text " + element + " is not a DOMNode object");
            return null;
        }
        if (element.innerText) {
            element.innerText = text;
        }
        else {
            element.textContent = text;
        }
    }
    setTextElements(elements, text) {
        const elementsLength = elements.length;
        for (let i = 0; i < elementsLength; i++) {
            this.setTextElement(elements[i], text);
        }
    }
    getTextElements(elements) {
        const results = [];
        const elementsLength = elements.length;
        for (let i = 0; i < elementsLength; i++) {
            results.push(this.getTextElement(elements[i]));
        }
        return results.join(' ');
    }
    text(element, text) {
        if (htmlService._isIterable(element)) {
            if (typeof text === 'string') {
                this.setTextElements(element, text);
            }
            else {
                return this.getTextElements(element);
            }
        }
        else {
            if (typeof text === 'string') {
                this.setTextElement(element, text);
            }
            else {
                return this.getTextElement(element);
            }
        }
    }
    isVisible(elements) {
        if (htmlService._isIterable(elements)) {
            return Array.from(elements).filter((element) => {
                return this.isVisible(element);
            });
        }
        return elements.offsetWidth && elements.offsetHeight;
    }
    empty(element) {
        element.innerHTML = '';
    }
    parents(element, selector) {
        if (!element) {
            return null;
        }
        element = element.parentNode;
        let parents = [];
        for (; element && element !== null; element = element.parentNode) {
            if (selector) {
                element = element.closest(selector);
                if (element) {
                    parents.push(element);
                }
                else {
                    return parents;
                }
                continue;
            }
            parents.push(element);
        }
        // Return parents if any exist
        if (parents.length === 0) {
            return null;
        }
        else {
            return parents;
        }
    }
    hasAttribute(elements, attribute) {
        if (htmlService._isIterable(elements)) {
            return this.hasAttribute(elements[0], attribute);
        }
        if (!htmlService.isNode(elements)) {
            console.error("Dom.hasAttribute " + elements + " is not a DOMNode object");
            return null;
        }
        return elements.hasAttribute(attribute);
    }
    /*
    In style attr will update only this items
    styles = {
    width:'300px',
    height: '25px'
    }*/
    updateStyleAttr(elements, updateStyles) {
        if (!updateStyles) {
            return null;
        }
        if (htmlService._isIterable(elements)) {
            Array.from(elements).forEach((elementNode) => {
                this.updateStyleAttr(elementNode, updateStyles);
            });
            return;
        }
        if (!htmlService.isNode(elements)) {
            console.error("Dom.updateStyleAttr " + elements + " is not a DOMNode object");
            return null;
        }
        let styleItems = this.getStyles(elements);
        if (typeof updateStyles === 'object') {
            for (let styleItem in updateStyles) {
                styleItems[styleItem] = updateStyles[styleItem];
            }
            elements.setAttribute('style', this.parseToStyleStr(styleItems));
        }
        else {
            console.error("Dom.updateStyleAttr " + updateStyles + " is not an object");
            return null;
        }
    }
    getStyles(element) {
        let stylesStr = dom.attr(element, "style");
        let styles = stylesStr ? stylesStr.split(";") : "";
        let i = styles.length;
        let json = {}, style, k, v;
        while (i--) {
            style = styles[i].split(':');
            k = new String(style[0]).trim();
            v = new String(style[1]).trim();
            if (k.length > 0 && v.length > 0) {
                json[k] = v;
            }
        }
        return json;
    }
    parseToStyleStr(styles) {
        let styleStr = "";
        Object.keys(styles).forEach((styleName) => {
            styleStr += styleName + ":" + styles[styleName] + ";";
        });
        return styleStr;
    }
    getDocumentHeight() {
        let doc = document;
        return Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight, doc.body.offsetHeight, doc.documentElement.offsetHeight, doc.body.clientHeight, doc.documentElement.clientHeight);
    }
    getWindowHeight() {
        return window.innerHeight || (document.documentElement || document.body).clientHeight;
    }
    getWindowYscroll() {
        return window.pageYOffset || (document.body || document.documentElement).scrollTop;
    }
    percentsScrolled() {
        return Math.floor(this.getWindowYscroll() / (this.getDocumentHeight() - this.getWindowHeight()) * 100);
    }
    hasScrollbar() {
        let rootElem = document.documentElement || document.body, overflowYStyle = window.getComputedStyle(rootElem, '').overflowY;
        let contentOverflows = rootElem.scrollHeight > rootElem.clientHeight, overflowShown = /^(visible|auto)$/.test(overflowYStyle), alwaysShowScroll = overflowYStyle === 'scroll';
        return (contentOverflows && overflowShown) || (alwaysShowScroll);
    }
    removeConnextScripts() {
        document.querySelectorAll(`script.${this.connextScriptClass}`).forEach((el) => {
            if (el.parentNode !== null) {
                el.parentNode.removeChild(el);
            }
        });
    }
    isExistElement(selector) {
        const element = dom.queryElement(selector);
        const isExists = !!element;
        return isExists;
    }
    clone(element) {
        return element.cloneNode(true);
    }
    nextSibling(element) {
        return element.nextSibling;
    }
    isChild(parent, child) {
        return child.parentNode == parent;
    }
    getType(element) {
        return element.nodeName.toLowerCase();
    }
    closest(element, selector) {
        return element.closest(selector);
    }
}
export const dom = new Dom();
